import { faqCollectionBodySchema } from "@redotech/redo-model/faq/faq-body-schema";
import * as z from "zod/v4";

export const updateCollection = {
  name: "updateCollection" as const,
  input: z.object({
    _id: z.string(),
    title: z.string().optional(),
    description: z.string().optional(),
    published: z.boolean().optional(),
  }),
  output: z.union([
    z.object({ ok: z.literal(true), value: faqCollectionBodySchema }),
    z.object({ ok: z.literal(false), error: z.string() }),
  ]),
};
